import { render, staticRenderFns } from "./indexAddresses.vue?vue&type=template&id=5ce22447&"
import script from "./indexAddresses.vue?vue&type=script&lang=ts&"
export * from "./indexAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports